import React, { useState, useEffect, useContext, useCallback } from 'react';
import Navbar from "../../../Shared/ManagerNavbar/Navbar";
import { Table, Select, Button, DatePicker, InputNumber, Input, Modal, Form, Card, Tag, Space, Spin, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import axios from 'axios';
import 'antd/dist/reset.css';
import { baseURL } from "../../../Apiservices/Api";
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../../../AuthContext/AuthContext';
import * as XLSX from 'xlsx';
import { useQuery } from '@tanstack/react-query';
import ReportComments from '../../../../Components/Pages/Admin/Report/ReportComments';
import "./Report.css";
import dayjs from 'dayjs';
const { Option } = Select;
const { RangePicker } = DatePicker;

const allFields = [
  { key: 'leadid', label: 'Opp ID', type: 'text' },
  { key: 'customerid', label: 'Customer Id', type: 'text' },
  { key: 'name', label: 'Name', type: 'text' },
  { key: 'email', label: 'Email', type: 'text' },
  { key: 'country_code', label: 'Country Code', type: 'text' },
  { key: 'phone_number', label: 'Phone', type: 'text' },
  { key: 'status', label: 'Status', type: 'text' },
  { key: 'primarySource', label: 'Primary Source', type: 'text' },
  { key: 'secondarysource', label: 'Secondary Source', type: 'text' },
  { key: 'travel_destination', label: 'Destination', type: 'text' },
  { key: 'assign_to_manager', label: 'Manager', type: 'text' },
  { key: 'assignedSalesName', label: 'Associate', type: 'text' },
  { key: 'description', label: 'Description', type: 'text' },
  { key: 'opportunity_status1', label: 'Primary Status', type: 'text' },
  { key: 'opportunity_status2', label: 'Secondary Status', type: 'text' },
  { key: 'start_date', label: 'Start Date', type: 'date' },
  { key: 'end_date', label: 'End Date', type: 'date' },
  { key: 'duration', label: 'Duration', type: 'text' },
  { key: 'approx_budget', label: 'Approx Budget', type: 'number' },
  { key: 'adults_count', label: 'Adults Count', type: 'number' },
  { key: 'children_count', label: 'Children Count', type: 'number' },
  { key: 'child_ages', label: 'Child Ages', type: 'text' },
  { key: 'travel_origincity', label: 'Origin City', type: 'text' },
  
  { key: 'travel_description', label: 'Description', type: 'text' },
  { key: 'tag_names', label: 'Tag', type: 'text' },
 { key: 'comment', label: 'Comment', type: 'date' },
  { key: 'travel_created_at', label: 'Created At', type: 'date' },
  { key: 'most_recent_updated_at', label: 'Updated At', type: 'date' },
  { key: 'supplier_total', label: 'Supplier Total', type: 'number' },
  { key: 'supplier_paid', label: 'Supplier Paid', type: 'number' },
  { key: 'supplier_balance', label: 'Supplier Balance', type: 'number' },
  { key: 'receivable_total', label: 'Receivable Total', type: 'number' },
  { key: 'receivable_paid', label: 'Receivable Paid', type: 'number' },
  { key: 'receivable_balance', label: 'Receivable Balance', type: 'number' },
];

const M_ReportBuilder = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("reportopp");
  const [collapsed, setCollapsed] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedFields, setSelectedFields] = useState(['name', 'email', 'phone_number', 'status',]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [availableFilterFields, setAvailableFilterFields] = useState([]);
  const [selectedFilterField, setSelectedFilterField] = useState(null);
  const [savedReports, setSavedReports] = useState([]);
  const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
  const [reportName, setReportName] = useState('');
  const [reportDescription, setReportDescription] = useState('');
  const [selectedReport, setSelectedReport] = useState(null);
  const [showSavedReports, setShowSavedReports] = useState(false);
  const [selectedLeadForComments, setSelectedLeadForComments] = useState(null);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [commentCounts, setCommentCounts] = useState({});
const [commentDates, setCommentDates] = useState({});

  // ─── FIX 1: Fetch saved reports – handle both array and nested response shapes ───
  useEffect(() => {
    const fetchSavedReports = async () => {
      if (!userId) return;
      try {
        const response = await axios.get(`${baseURL}/api/users/${userId}/reports`);
        const reports = Array.isArray(response.data)
          ? response.data
          : (response.data?.data || []);
        const oppReports = reports.filter(r => r.type === "Opp");
        setSavedReports(oppReports);
      } catch (error) {
        console.error('Error fetching user reports:', error);
        const local = JSON.parse(localStorage.getItem('savedManagerOppReports') || '[]');
        setSavedReports(local.filter(r => r.userId === userId && r.type === "Opp"));
      }
    };
    fetchSavedReports();
  }, [userId]);

  useEffect(() => {
    localStorage.setItem('savedManagerOppReports', JSON.stringify(savedReports));
  }, [savedReports]);

  // ─── FIX 2: Remove refetchInterval – root cause of ERR_INSUFFICIENT_RESOURCES ───
  const { data: rawData = [], isLoading } = useQuery({
    queryKey: ['lead-suppliers-manager', userId],
    refetchInterval: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await axios.get(`${baseURL}/api/fetch-lead-suppliers-manager-report/${userId}`);
      return response.data;
    },
    enabled: !!userId,
    keepPreviousData: true,
  });

  const { data: tags = [], isLoading: tagsLoading } = useQuery({
    queryKey: ['tags'],
    queryFn: async () => {
      const response = await axios.get(`${baseURL}/api/tags`);
      return response.data;
    },
    keepPreviousData: true,
  });

const fetchCommentCounts = useCallback(async (leads) => {
  if (!leads || leads.length === 0) return;

  const leadIds = leads.map(l => l.leadid);

  try {
    const response = await axios.post(`${baseURL}/comments/bulk-counts`, { leadIds });
    const { counts, dates } = response.data;

    const parsedDates = {};
    Object.keys(dates).forEach(id => {
      parsedDates[id] = dates[id]
        .map(d => new Date(d))
        .filter(d => !isNaN(d.getTime()));
    });

    setCommentCounts(prev => {
      const hasChanged = Object.keys(counts).some(k => prev[k] !== counts[k]);
      return hasChanged ? { ...prev, ...counts } : prev;
    });
    setCommentDates(prev => ({ ...prev, ...parsedDates }));

  } catch (error) {
    console.error('Bulk comment fetch failed:', error);
  }
}, [baseURL]);

  // ─── FIX 4: Only re-fetch when NUMBER of records changes, not on every render ───
  useEffect(() => {
    if (rawData && rawData.length > 0) {
      fetchCommentCounts(rawData);
    }
  }, [rawData?.length]);



  useEffect(() => {
    setFilteredData(applyFilters(rawData));
  }, [selectedFields, activeFilters, rawData,commentDates]); 

useEffect(() => {
    const available = allFields
      .filter(field => !activeFilters.some(f => f.field.key === field.key));
    setAvailableFilterFields(available);
    setSelectedFilterField(available[0]?.key || null);
  }, [activeFilters]);


    const handleCloseCommentsModal = useCallback(() => {
      setShowCommentsModal(false);
      setSelectedLeadForComments(null);
      if (rawData && rawData.length > 0) {
        fetchCommentCounts(rawData);
      }
    }, [rawData]);
    
    const handleCommentsModalHide = useCallback(() => {
      handleCloseCommentsModal();
    }, [handleCloseCommentsModal]);

  const applyFilters = (data) => {
    if (!data || data.length === 0) return [];
    let result = [...data];

    activeFilters.forEach(filter => {
      const { field, value } = filter;

      if (field.type === 'text') {
        if (value && value.length > 0) {
          result = result.filter(item => {
            if (field.key.startsWith('supplier_')) {
              const f = field.key.replace('supplier_', '');
              const vals = item.suppliers?.map(s => s[f]) || [];
              return value.some(val => vals.some(v => String(v).toLowerCase().includes(String(val).toLowerCase())));
            } else if (field.key.startsWith('payment_')) {
              const f = field.key.replace('payment_', '');
              const vals = item.payment_logs?.map(p => p[f]) || [];
              return value.some(val => vals.some(v => String(v).toLowerCase().includes(String(val).toLowerCase())));
            } else if (field.key.startsWith('receivable_')) {
              const f = field.key.replace('receivable_', '');
              const vals = item.receivables?.map(r => r[f]) || [];
              return value.some(val => vals.some(v => String(v).toLowerCase().includes(String(val).toLowerCase())));
            } else {
              const itemValue = item[field.key] || '';
              return value.some(val => String(itemValue).toLowerCase().includes(String(val).toLowerCase()));
            }
          });
        }
      } else if (field.type === 'number') {
        if (value?.min !== undefined && value?.min !== null) result = result.filter(item => (item[field.key] || 0) >= value.min);
        if (value?.max !== undefined && value?.max !== null) result = result.filter(item => (item[field.key] || 0) <= value.max);
      }
       else if (field.key === 'comment' && field.type === 'date' && value && value.length === 2) {
      const [startDateTime, endDateTime] = value;
    const start = startDateTime
  ? new Date(typeof startDateTime.valueOf === 'function' ? startDateTime.valueOf() : startDateTime)
  : null;
const end = endDateTime
  ? new Date(typeof endDateTime.valueOf === 'function' ? endDateTime.valueOf() : endDateTime)
  : null;
      if (end) { end.setSeconds(59); end.setMilliseconds(999); }

       result = result.filter(item => {
        const leadCommentDates = commentDates[item.leadid] || [];
        if (leadCommentDates.length === 0) return false;
        return leadCommentDates.some(commentDate => {
          if (!commentDate || isNaN(commentDate)) return false;
          if (start && end) return commentDate >= start && commentDate <= end;
          if (start) return commentDate >= start;
          if (end) return commentDate <= end;
          return true;
        });
      });
    }
      else if (field.type === 'date' && value && value.length === 2) {
        const [startDateTime, endDateTime] = value;
        const start = startDateTime ? new Date(startDateTime) : null;
        const end = endDateTime ? new Date(endDateTime) : null;
        if (end) { end.setSeconds(59); end.setMilliseconds(999); }

        result = result.filter(item => {
          if (field.key === 'payment_paid_on') {
            const dates = item.payment_logs?.map(log => log.paid_on ? new Date(log.paid_on) : null) || [];
            return dates.some(date => {
              if (!date) return false;
              if (start && end) return date >= start && date <= end;
              if (start) return date >= start;
              if (end) return date <= end;
              return true;
            });
          }
          const itemDate = item[field.key] ? new Date(item[field.key]) : null;
          if (!itemDate) return false;
          if (start && end) return itemDate >= start && itemDate <= end;
          if (start) return itemDate >= start;
          if (end) return itemDate <= end;
          return true;
        });
      }
    });

    return result;
  };

  const formatIndianDateTime = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const generateColumns = () => {
    const dateFields = ['start_date', 'end_date', 'travel_created_at', 'most_recent_updated_at', 'payment_paid_on'];

    return selectedFields.map(fieldKey => {
      const field = allFields.find(f => f.key === fieldKey);
      if (!field) return null;

      const isFirst = selectedFields.indexOf(fieldKey) === 0;
      let width = 150;
      if (fieldKey === 'name') width = 200;
      if (fieldKey === 'email') width = 220;
      if (fieldKey === 'phone_number') width = 130;
      if (fieldKey === 'leadid') width = 100;
      if (fieldKey === 'customerid') width = 120;
      if (['status', 'opportunity_status1', 'opportunity_status2'].includes(fieldKey)) width = 140;
      if (['primarySource', 'secondarysource'].includes(fieldKey)) width = 160;
      if (['travel_destination', 'travel_origincity'].includes(fieldKey)) width = 120;
      if (dateFields.includes(fieldKey)) width = 180;
      if (['approx_budget', 'adults_count', 'children_count'].includes(fieldKey)) width = 130;
      if (fieldKey === 'tag_names') width = 200;
      if (fieldKey === 'comment') width = 120;
      if (['supplier_total', 'supplier_paid', 'supplier_balance', 'receivable_total', 'receivable_paid', 'receivable_balance'].includes(fieldKey)) width = 150;

      const cellStyle = { width, minWidth: width, maxWidth: width, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
      const headerStyle = { width, minWidth: width, maxWidth: width, whiteSpace: 'nowrap' };
      const base = {
        title: field.label,
        key: fieldKey,
        width,
        fixed: isFirst ? 'left' : false,
        ellipsis: true,
        onHeaderCell: () => ({ style: headerStyle }),
        onCell: () => ({ style: cellStyle }),
      };
      if (fieldKey === 'name') {
  return {
    title: field.label,
    dataIndex: fieldKey,
    key: fieldKey,
    width: 80,
    fixed: selectedFields.indexOf(fieldKey) === 0 ? 'left' : false,
    sorter: (a, b) => String(a[fieldKey] || '').localeCompare(String(b[fieldKey] || '')),
    ellipsis: true,
    render: (value, record) => (
      <span
 style={{ 
      color: '#1890ff', 
      cursor: 'pointer', 
      textDecoration: 'underline',
      textDecorationColor: '#1890ff',   
      textUnderlineOffset: '4px'       
    }}
            onClick={() => {
          setSelectedLeadForComments(record);   
          setShowCommentsModal(true);           
        }}
      >
        {value || '-'}
      </span>
    ),
  };
}

      // Comment column
      if (fieldKey === 'comment') {
        return {
          ...base,
          sorter: (a, b) => (commentCounts[a.leadid] || 0) - (commentCounts[b.leadid] || 0),
          render: (_, record) => {
            const commentCount = commentCounts[record.leadid] || 0;
            return (
              <Button
                type="primary"
                size="small"
                disabled={commentCount === 0}
                onClick={() => { setSelectedLeadForComments(record); setShowCommentsModal(true); }}
                style={{
                  backgroundColor: commentCount > 0 ? "#ff9966" : "#d9d9d9",
                  borderColor: commentCount > 0 ? "#ff9966" : "#d9d9d9",
                  width: '100px',
                }}
              >
                {commentCount > 0 ? `${commentCount} Comment${commentCount > 1 ? 's' : ''}` : 'No Comments'}
              </Button>
            );
          },
        };
      }

      // Date columns
      if (dateFields.includes(fieldKey)) {
        return { ...base, dataIndex: fieldKey, sorter: (a, b) => new Date(a[fieldKey] || 0) - new Date(b[fieldKey] || 0), render: formatIndianDateTime };
      }

      // Tag names
      if (fieldKey === 'tag_names') {
        return {
          ...base, dataIndex: fieldKey,
          sorter: (a, b) => {
            const aStr = Array.isArray(a[fieldKey]) ? a[fieldKey].join(', ') : String(a[fieldKey] || '');
            const bStr = Array.isArray(b[fieldKey]) ? b[fieldKey].join(', ') : String(b[fieldKey] || '');
            return aStr.localeCompare(bStr);
          },
          render: (value) => {
            if (!value) return '-';
            if (Array.isArray(value)) return value.join(', ');
            return value || '-';
          },
        };
      }

      // Financial summary columns
      if (fieldKey === 'supplier_total') return { ...base, render: (_, r) => `₹${(r.suppliers?.reduce((s, x) => s + (Number(x.total_payable) || 0), 0) || 0).toFixed(2)}` };
      if (fieldKey === 'supplier_paid') return { ...base, render: (_, r) => `₹${((r.payment_logs || []).reduce((s, x) => s + (Number(x.paid_amount) || 0), 0)).toFixed(2)}` };
      if (fieldKey === 'supplier_balance') {
        return {
          ...base, render: (_, r) => {
            const total = r.suppliers?.reduce((s, x) => s + (Number(x.total_payable) || 0), 0) || 0;
            const paid = (r.payment_logs || []).reduce((s, x) => s + (Number(x.paid_amount) || 0), 0);
            return `₹${(total - paid).toFixed(2)}`;
          }
        };
      }
      if (fieldKey === 'receivable_total') return { ...base, render: (_, r) => `₹${(Number(r.approx_budget) || 0).toFixed(2)}` };
      if (fieldKey === 'receivable_paid') return { ...base, render: (_, r) => `₹${((r.receivables || []).reduce((s, x) => s + (Number(x.paid_amount) || 0), 0)).toFixed(2)}` };
      if (fieldKey === 'receivable_balance') {
        return {
          ...base, render: (_, r) => {
            const total = Number(r.approx_budget) || 0;
            const paid = (r.receivables || []).reduce((s, x) => s + (Number(x.paid_amount) || 0), 0);
            return `₹${(total - paid).toFixed(2)}`;
          }
        };
      }

      // Supplier/payment/receivable sub-fields
      if (fieldKey.startsWith('supplier_') && !['supplier_total', 'supplier_paid', 'supplier_balance'].includes(fieldKey)) {
        return { ...base, render: (_, r) => r.suppliers?.length ? r.suppliers.map(s => s[fieldKey.replace('supplier_', '')]).join(', ') : '-' };
      }
      if (fieldKey.startsWith('payment_')) {
        return { ...base, render: (_, r) => r.payment_logs?.length ? r.payment_logs.map(p => p[fieldKey.replace('payment_', '')]).join(', ') : '-' };
      }
      if (fieldKey.startsWith('receivable_') && !['receivable_total', 'receivable_paid', 'receivable_balance'].includes(fieldKey)) {
        return { ...base, render: (_, r) => r.receivables?.length ? r.receivables.map(x => x[fieldKey.replace('receivable_', '')]).join(', ') : '-' };
      }

      // Default
      return {
        ...base,
        dataIndex: fieldKey,
        sorter: (a, b) => {
          if (field.type === 'number') return (a[fieldKey] || 0) - (b[fieldKey] || 0);
          return String(a[fieldKey] || '').localeCompare(String(b[fieldKey] || ''));
        },
        render: value => value || '-',
      };
    }).filter(Boolean);
  };

  const filterComponents = {
    text: ({ field, value, onChange, onRemove }) => {
      if (field.key === 'tag_names') {
        return (
          <Select
            mode="multiple" style={{ width: 250 }} placeholder="Select tags"
            value={value} onChange={onChange} loading={tagsLoading} allowClear
            options={tags.map(tag => ({ value: tag.value, label: tag.label }))}
            dropdownRender={menu => (
              <div>{menu}<div style={{ padding: '5px', textAlign: 'right' }}><Button size="small" danger onClick={onRemove}>Remove Filter</Button></div></div>
            )}
          />
        );
      }
      const uniqueValues = [...new Set(rawData.map(item => item[field.key]))];
      return (
        <Select
          mode="multiple" style={{ width: 200 }} placeholder={`Select ${field.label}`}
          value={value} onChange={onChange}
          dropdownRender={menu => (
            <div>{menu}<div style={{ padding: '5px', textAlign: 'right' }}><Button size="small" danger onClick={onRemove}>Remove Filter</Button></div></div>
          )}
        >
          {uniqueValues.map(val => <Option key={val} value={val}>{val || '(Empty)'}</Option>)}
        </Select>
      );
    },
    number: ({ field, value, onChange, onRemove }) => (
      <Space>
        <InputNumber placeholder={`Min ${field.label}`} value={value?.min} onChange={min => onChange({ ...value, min })} style={{ width: 100 }} />
        <InputNumber placeholder={`Max ${field.label}`} value={value?.max} onChange={max => onChange({ ...value, max })} style={{ width: 100 }} />
        <Button danger icon={<CloseOutlined />} onClick={onRemove} />
      </Space>
    ),
    date: ({ value, onChange, onRemove }) => (
      <Space direction="vertical" size="small">
        <RangePicker value={value} onChange={onChange} format="YYYY-MM-DD HH:mm" showTime={{ format: 'HH:mm' }} placeholder={['Start Date & Time', 'End Date & Time']} />
        <Button danger icon={<CloseOutlined />} onClick={onRemove} size="small">Remove Filter</Button>
      </Space>
    ),
  };

  const handleFieldChange = (values) => setSelectedFields(values);

  const addFilter = () => {
    if (!selectedFilterField) return;
    const field = allFields.find(f => f.key === selectedFilterField);
    if (!field) return;
    setActiveFilters([...activeFilters, {
      id: Date.now(), field,
      value: field.type === 'number' ? { min: null, max: null } : field.type === 'date' ? null : [],
    }]);
  };

  const updateFilter = (id, newValue) => setActiveFilters(activeFilters.map(f => f.id === id ? { ...f, value: newValue } : f));
  const removeFilter = (id) => setActiveFilters(activeFilters.filter(f => f.id !== id));

  const exportToExcel = async () => {
    const mainData = filteredData.map(item => {
      const row = {};
      const dateFields = ['start_date', 'end_date', 'travel_created_at', 'most_recent_updated_at'];
      selectedFields.forEach(field => {
        const fieldInfo = allFields.find(f => f.key === field);
        const label = fieldInfo?.label || field;
        if (dateFields.includes(field)) {
          row[label] = formatIndianDateTime(item[field]);
        } else if (field === 'supplier_total') {
          row[label] = `₹${(item.suppliers?.reduce((s, x) => s + (Number(x.total_payable) || 0), 0) || 0).toFixed(2)}`;
        } else if (field === 'supplier_paid') {
          row[label] = `₹${((item.payment_logs || []).reduce((s, x) => s + (Number(x.paid_amount) || 0), 0)).toFixed(2)}`;
        } else if (field === 'supplier_balance') {
          const total = item.suppliers?.reduce((s, x) => s + (Number(x.total_payable) || 0), 0) || 0;
          const paid = (item.payment_logs || []).reduce((s, x) => s + (Number(x.paid_amount) || 0), 0);
          row[label] = `₹${(total - paid).toFixed(2)}`;
        } else if (field === 'receivable_total') {
          row[label] = `₹${(Number(item.approx_budget) || 0).toFixed(2)}`;
        } else if (field === 'receivable_paid') {
          row[label] = `₹${((item.receivables || []).reduce((s, r) => s + (Number(r.paid_amount) || 0), 0)).toFixed(2)}`;
        } else if (field === 'receivable_balance') {
          const total = Number(item.approx_budget) || 0;
          const paid = (item.receivables || []).reduce((s, r) => s + (Number(r.paid_amount) || 0), 0);
          row[label] = `₹${(total - paid).toFixed(2)}`;
        }else if (field === 'tag_names') {
          const tagVal = item[field];
          row[label] = Array.isArray(tagVal) ? tagVal.join(', ') : (tagVal || '');
        }
         else if (field === 'comment') {
        const count = commentCounts[item.leadid] || 0;
        row[label] = count > 0 ? `${count} Comment${count > 1 ? 's' : ''}` : 'No Comments';
      } 
        else {
          row[label] = item[field] || '';
        }
      });
      return row;
    });

    const combinedData = [];
    filteredData.forEach(lead => {
      combinedData.push({ 'Supplier Name': `LEAD ID: ${lead.leadid} - ${lead.name}`, 'Total Payable': '', 'Paid Amount': '', 'Balance Payment': '', 'Status': '', ' ': '', '  ': '', '   ': '', 'Receivable Name': '', 'Amount': '', 'Paid': '', 'Remarks': '', 'Receivable Status': '' });
      combinedData.push({ 'Supplier Name': 'SUPPLIERS', 'Total Payable': '', 'Paid Amount': '', 'Balance Payment': '', 'Status': '', ' ': '', '  ': '', '   ': '', 'Receivable Name': 'RECEIVABLES', 'Amount': '', 'Paid': '', 'Remarks': '', 'Receivable Status': '' });
      combinedData.push({ 'Supplier Name': 'Supplier Name', 'Total Payable': 'Total Payable', 'Paid Amount': 'Paid Amount', 'Balance Payment': 'Balance Payment', 'Status': 'Status', ' ': '', '  ': '', '   ': '', 'Receivable Name': 'Paid On', 'Amount': 'Paid Amount', 'Paid': 'Remarks', 'Receivable Status': 'Status' });

      const maxLength = Math.max(lead.suppliers?.length || 0, lead.receivables?.length || 0);
      for (let i = 0; i < maxLength; i++) {
        const row = {};
        if (i < (lead.suppliers?.length || 0)) {
          const s = lead.suppliers[i];
          const sp = (lead.payment_logs || []).filter(log => String(log.supplier_id) === String(s.id));
          const totalPaid = sp.reduce((sum, log) => sum + (Number(log.paid_amount) || 0), 0);
          const totalPayable = Number(s.total_payable) || 0;
          row['Supplier Name'] = s.supplier_name;
          row['Total Payable'] = `₹${totalPayable.toFixed(2)}`;
          row['Paid Amount'] = `₹${totalPaid.toFixed(2)}`;
          row['Balance Payment'] = `₹${(totalPayable - totalPaid).toFixed(2)}`;
          row['Status'] = s.status;
        }
        if (i < (lead.receivables?.length || 0)) {
          const r = lead.receivables[i];
          row['Receivable Name'] = r.paid_on ? formatIndianDateTime(r.paid_on) : '';
          row['Amount'] = `₹${(Number(r.paid_amount) || 0).toFixed(2)}`;
          row['Paid'] = r.remarks || '';
          row['Receivable Status'] = r.status;
        }
        combinedData.push(row);
      }

      const supplierTotal = lead.suppliers?.reduce((s, x) => s + Number(x.total_payable || 0), 0) || 0;
      const supplierPaid = lead.payment_logs?.reduce((s, x) => s + Number(x.paid_amount || 0), 0) || 0;
      const receivableTotal = Number(lead.approx_budget || 0);
      const receivablePaid = lead.receivables?.reduce((s, r) => s + Number(r.paid_amount || 0), 0) || 0;

      combinedData.push({
        'Supplier Name': 'SUMMARY', 'Total Payable': `Total : ₹${supplierTotal.toFixed(2)}`,
        'Paid Amount': `Paid : ₹${supplierPaid.toFixed(2)}`, 'Balance Payment': `Balance : ₹${(supplierTotal - supplierPaid).toFixed(2)}`,
        'Status': '', ' ': '', '  ': '', '   ': '', 'Receivable Name': 'SUMMARY',
        'Amount': `Total : ₹${receivableTotal.toFixed(2)}`, 'Paid': `Paid : ₹${receivablePaid.toFixed(2)}`,
        'Receivable Status': `Balance : ₹${(receivableTotal - receivablePaid).toFixed(2)}`
      });
      combinedData.push({});
    });


     const commentRows = [];
    
      try {
        const allLeadIds = filteredData.map(l => l.leadid);
        const response = await axios.post(`${baseURL}/comments/bulk-counts`, { leadIds: allLeadIds });
        const { comments } = response.data;
    
        const leadMap = {};
        filteredData.forEach(item => {
          leadMap[item.leadid] = item.name || '-';
        });
    
        Object.keys(comments).forEach(leadId => {
          const leadComments = comments[leadId];
          if (!leadComments || leadComments.length === 0) return;
    
          leadComments.forEach(({ date, text, name }) => {
            const d = new Date(date);
            if (isNaN(d.getTime())) return;
    
            const day     = d.getDate().toString().padStart(2, '0');
            const month   = (d.getMonth() + 1).toString().padStart(2, '0');
            const year    = d.getFullYear();
            const hours   = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const seconds = d.getSeconds().toString().padStart(2, '0');
    
            commentRows.push({
              'Opp ID':       leadId,
              'Lead Name':    leadMap[leadId] || '-',
             
              'Comment Date': `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`,
              'Comment':      text || '-',
            });
          });
        });
    
        commentRows.sort((a, b) => {
          if (String(a['Opp ID']) !== String(b['Opp ID']))
            return String(a['Opp ID']).localeCompare(String(b['Opp ID']));
          return new Date(a['Comment Date']) - new Date(b['Comment Date']);
        });
    
      } catch (error) {
        console.error('Failed to fetch comment data for export:', error);
      }
    
    const mainWorksheet = XLSX.utils.json_to_sheet(mainData);
    const combinedWorksheet = XLSX.utils.json_to_sheet(combinedData);
    combinedWorksheet['!cols'] = [{ width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 20 }, { width: 15 }, { width: 2 }, { width: 2 }, { width: 15 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }];
    combinedWorksheet['!merges'] = [];
    combinedData.forEach((row, index) => {
      if (row['Supplier Name']?.includes('LEAD ID:')) combinedWorksheet['!merges'].push({ s: { r: index, c: 0 }, e: { r: index, c: 13 } });
      else if (row['Supplier Name'] === 'SUPPLIERS') {
        combinedWorksheet['!merges'].push({ s: { r: index, c: 0 }, e: { r: index, c: 5 } });
        combinedWorksheet['!merges'].push({ s: { r: index, c: 9 }, e: { r: index, c: 13 } });
      }
    });


      const ws3 = XLSX.utils.json_to_sheet(                           
        commentRows.length > 0
          ? commentRows
          : [{ 'Opp ID': '', 'Lead Name': 'No comments found', 'Comment Date': '', 'Comment': '' }]
      );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, mainWorksheet, "Leads");
    XLSX.utils.book_append_sheet(workbook, combinedWorksheet, "Suppliers & Payments");
        XLSX.utils.book_append_sheet(workbook, ws3, "Comment Details");
    
    XLSX.writeFile(workbook, `opportunity_report_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const showSaveModal = () => setIsSaveModalVisible(true);
  const toggleSavedReports = () => setShowSavedReports(!showSavedReports);

  const saveReportToBoth = async (report) => {
    try {
      const response = await axios.post(`${baseURL}/api/reports`, report);
      const newReport = response.data;
      setSavedReports(prev => { const u = [...prev, newReport]; localStorage.setItem('savedManagerOppReports', JSON.stringify(u)); return u; });
      return newReport;
    } catch {
      const newReport = { ...report, id: Date.now(), createdAt: new Date().toISOString() };
      setSavedReports(prev => { const u = [...prev, newReport]; localStorage.setItem('savedManagerOppReports', JSON.stringify(u)); return u; });
      return newReport;
    }
  };

  const deleteReportFromBoth = async (reportId) => {
    try { await axios.delete(`${baseURL}/api/reports/${reportId}`); } catch { }
    setSavedReports(prev => { const u = prev.filter(r => r.id !== reportId); localStorage.setItem('savedManagerOppReports', JSON.stringify(u)); return u; });
  };

  const handleSaveReport = async () => {
    if (!reportName.trim()) { message.error('Please enter a report name'); return; }
    try {
      await saveReportToBoth({ name: reportName, description: reportDescription, selectedFields: [...selectedFields], activeFilters: [...activeFilters], userId, type: "Opp" });
      setIsSaveModalVisible(false); setReportName(''); setReportDescription('');
      message.success('Report saved successfully');
      setShowSavedReports(true);
    } catch { message.error('Failed to save report'); }
  };

  const deleteReport = async (reportId, e) => {
    e.stopPropagation();
    try { await deleteReportFromBoth(reportId); if (selectedReport === reportId) setSelectedReport(null); message.success('Report deleted'); }
    catch { message.error('Failed to delete report'); }
  };

const loadReport = (report) => {
  const restoredFilters = report.activeFilters.map(filter => {
    if (filter.field.type === 'date') {
      // Convert saved ISO strings → dayjs objects so RangePicker displays them
      const restoredValue = Array.isArray(filter.value) && filter.value.length === 2
        ? [
            filter.value[0] ? dayjs(filter.value[0]) : null,
            filter.value[1] ? dayjs(filter.value[1]) : null,
          ]
        : null;
      return { ...filter, value: restoredValue };
    }
    return filter;
  });

  setSelectedFields(report.selectedFields);
  setActiveFilters(restoredFilters);
  setSelectedReport(report.id);
  message.info(`Loaded report: ${report.name}`);
  setShowSavedReports(false);
};
  return (
    <div className="Admin-reportcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Admin-report ${collapsed ? "collapsed" : ""}`}>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

          <div className="payments-tabs">
            <button className={activeTab === "reportleads" ? "active" : ""} onClick={() => { setActiveTab("reportleads"); navigate(`/M_Report/`); }}>Leads</button>
            <button className={activeTab === "reportopp" ? "active" : ""} onClick={() => setActiveTab("reportopp")}>Opportunity</button>
          </div>

          <Card style={{ padding: '16px', margin: '16px 0', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', backgroundColor: 'rgba(163, 110, 41, 0.08)' }}>
            <div><h3 className='text-center'>Reports</h3></div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '16px', flexWrap: 'nowrap' }}>
              <div style={{ display: "flex", gap: "10px", flex: 1, minWidth: 0 }}>
                <div style={{ width: "350px", flexShrink: 0 }}>
                  <Select mode="multiple" placeholder="Select fields to include in report" value={selectedFields.length ? selectedFields : undefined} onChange={handleFieldChange} tagRender={() => null} style={{ width: "100%", height: "34px" }}>
                    {allFields.map(field => <Option key={field.key} value={field.key}>{field.label}</Option>)}
                  </Select>
                </div>
                <div style={{ width: "420px", overflowX: "auto", scrollbarWidth: "thin", minWidth: 0 }}>
                  <div style={{ border: "1px solid #d9d9d9", borderRadius: "6px", height: "34px", padding: "4px 10px", display: "flex", alignItems: "center", gap: "10px", whiteSpace: "nowrap", minWidth: "max-content" }}>
                    {selectedFields.map(key => {
                      const field = allFields.find(f => f.key === key);
                      return <Tag key={key} closable style={{ fontSize: "14px", padding: "2px 10px", margin: 0 }} onClose={() => setSelectedFields(selectedFields.filter(f => f !== key))}>{field?.label}</Tag>;
                    })}
                  </div>
                </div>
              </div>
              <Space style={{ flexShrink: 0 }}>
                <Button onClick={exportToExcel} type="primary">Export to Excel</Button>
                <Button onClick={showSaveModal}>Save Report</Button>
                <Button onClick={toggleSavedReports}>{showSavedReports ? 'Hide Saved' : 'Show Saved'}</Button>
              </Space>
            </div>

            {/* Filters */}
            <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#fafafa', border: '1px solid #d9d9d9', borderRadius: '4px', overflowX: 'auto', whiteSpace: 'nowrap' }}>
              <Space size="middle">
                {activeFilters.length > 0 ? activeFilters.map(filter => {
                  const FilterComponent = filterComponents[filter.field.type];
                  return (
                    <div key={filter.id} style={{ display: 'inline-block', padding: '8px', border: '1px solid #d9d9d9', borderRadius: '4px', backgroundColor: 'white' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{filter.field.label}</div>
                      <FilterComponent field={filter.field} value={filter.value} onChange={(value) => updateFilter(filter.id, value)} onRemove={() => removeFilter(filter.id)} />
                    </div>
                  );
                }) : <span style={{ color: '#999' }}>No filters applied</span>}
              </Space>
              <div style={{ display: 'inline-block', marginLeft: '16px', verticalAlign: 'top' }}>
                <Space>
                  <Select style={{ width: 200 }} value={selectedFilterField} onChange={setSelectedFilterField} disabled={availableFilterFields.length === 0}>
                    {availableFilterFields.map(field => <Option key={field.key} value={field.key}>{field.label}</Option>)}
                  </Select>
                  <Button type="primary" onClick={addFilter} disabled={availableFilterFields.length === 0}>Add Filter</Button>
                  {activeFilters.length > 0 && <Button danger onClick={() => setActiveFilters([])}>Clear All</Button>}
                </Space>
              </div>
            </div>

            {/* Table + Sidebar */}
            <div style={{ overflowX: 'auto' }}>
              <div style={{ display: 'flex', flex: 1, gap: '16px', minWidth: '1000px' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                  <div style={{ marginBottom: '8px' }}><h3>Opportunity Report ({filteredData.length} records)</h3></div>
                  <Spin spinning={isLoading}>
                    <Table
                      columns={generateColumns()}
                      dataSource={filteredData}
                      rowKey="leadid"
                      pagination={{ pageSize: 10 }}
                      bordered
                      scroll={{ x: 'max-content', y: '100%' }}
                      style={{ minWidth: '100%' }}
                      expandable={{
                        expandedRowRender: (record) => (
                          <div style={{ margin: 0 }}>
                            <h4>Suppliers</h4>
                            {record.suppliers?.length > 0 ? (() => {
                              let grandTotalPayable = 0, grandTotalPaid = 0;
                              const updatedSuppliers = record.suppliers.map(supplier => {
                                const sp = (record.payment_logs || []).filter(log => String(log.supplier_id) === String(supplier.id));
                                const totalPaid = sp.reduce((sum, log) => sum + (Number(log.paid_amount) || 0), 0);
                                const totalPayable = Number(supplier.total_payable) || 0;
                                grandTotalPayable += totalPayable; grandTotalPaid += totalPaid;
                                return { ...supplier, paid_amount: `₹${totalPaid.toFixed(2)}`, balance_payment: `₹${(totalPayable - totalPaid).toFixed(2)}` };
                              });
                              const grandBalance = grandTotalPayable - grandTotalPaid;
                              return (
                                <>
                                  <Table
                                    columns={[
                                      { title: 'Name', dataIndex: 'supplier_name', key: 'supplier_name' },
                                      { title: 'Total Payable', dataIndex: 'total_payable', key: 'total_payable' },
                                      { title: 'Paid Amount', dataIndex: 'paid_amount', key: 'paid_amount' },
                                      { title: 'Balance', dataIndex: 'balance_payment', key: 'balance_payment' },
                                      { title: 'Status', dataIndex: 'status', key: 'status' },
                                    ]}
                                    dataSource={updatedSuppliers} rowKey="id" size="small" pagination={false}
                                  />
                                  <div style={{ display: 'flex', gap: "24px", marginTop: '1rem', fontWeight: 'bold' }}>
                                    <p>Total Payable: ₹{grandTotalPayable.toFixed(2)}</p>
                                    <p>Total Paid: ₹{grandTotalPaid.toFixed(2)}</p>
                                    <p>Total Balance: ₹{grandBalance.toFixed(2)}</p>
                                  </div>
                                </>
                              );
                            })() : <p>No suppliers</p>}

                            <h4 style={{ marginTop: 16 }}>Receivables</h4>
                            {record.receivables?.length > 0 ? (
                              <div>
                                <div style={{ marginBottom: 8, fontWeight: 600, display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
                                  {(() => {
                                    const totalAmount = Number(record.approx_budget) || 0;
                                    const totalPaid = record.receivables.reduce((sum, r) => sum + (Number(r.paid_amount) || 0), 0);
                                    return (<><div>Total Amount: ₹{totalAmount.toFixed(2)}</div><div>Total Paid: ₹{totalPaid.toFixed(2)}</div><div>Balance: ₹{(totalAmount - totalPaid).toFixed(2)}</div></>);
                                  })()}
                                </div>
                                <Table
                                  columns={[
                                    { title: 'Received On', dataIndex: 'paid_on', key: 'paid_on' },
                                    { title: 'Received Amount', dataIndex: 'paid_amount', key: 'paid_amount' },
                                    { title: 'Remarks', dataIndex: 'remarks', key: 'remarks' },
                                    { title: 'Status', dataIndex: 'status', key: 'status' },
                                  ]}
                                  dataSource={record.receivables} rowKey="id" size="small" pagination={false}
                                />
                              </div>
                            ) : <p>No Receivables</p>}
                          </div>
                        ),
                        rowExpandable: (record) => record.suppliers?.length > 0 || record.payment_logs?.length > 0 || record.receivables?.length > 0,
                      }}
                    />
                  </Spin>
                </div>

                {showSavedReports && (
                  <div style={{ width: '300px', borderLeft: '1px solid #d9d9d9', paddingLeft: '16px', overflowY: 'auto' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                      <h3>Saved Reports</h3>
                      <Button size="small" icon={<CloseOutlined />} onClick={() => setShowSavedReports(false)} />
                    </div>
                    {savedReports.length === 0 ? <p>No saved reports yet</p> : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {savedReports.map(report => (
                          <Card key={report.id} onClick={() => loadReport(report)} size="small"
                            style={{ cursor: 'pointer', borderColor: selectedReport === report.id ? '#1890ff' : '#d9d9d9', backgroundColor: selectedReport === report.id ? '#e6f7ff' : 'white' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ flex: 1, overflow: 'hidden' }}>
                                <h4 style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: 0 }}>{report.name}</h4>
                                <p style={{ color: '#666', fontSize: '12px', margin: '4px 0' }}>{new Date(report.created_at).toLocaleString()}</p>
                                {report.description && <p style={{ fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: 0 }}>{report.description}</p>}
                                <div style={{ marginTop: '4px' }}>
                                  <Tag color="blue" style={{ marginRight: 0 }}>{report.selectedFields.length} cols</Tag>
                                  <Tag color="orange">{report.activeFilters.length} filters</Tag>
                                </div>
                              </div>
                              <Button danger size="small" onClick={(e) => deleteReport(report.id, e)} style={{ marginLeft: '8px' }}>Delete</Button>
                            </div>
                          </Card>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Card>
        </div>

        <Modal title="Save Report Configuration" open={isSaveModalVisible} onOk={handleSaveReport} onCancel={() => setIsSaveModalVisible(false)} width={700}>
          <Form layout="vertical">
            <Form.Item label="Report Name" required>
              <Input value={reportName} onChange={(e) => setReportName(e.target.value)} placeholder="Enter report name" />
            </Form.Item>
            <Form.Item label="Description">
              <Input.TextArea value={reportDescription} onChange={(e) => setReportDescription(e.target.value)} placeholder="Enter description (optional)" rows={3} />
            </Form.Item>
            <Form.Item label="Selected Fields">
              <div style={{ padding: '10px', background: '#f5f5f5', borderRadius: '4px', maxHeight: '150px', overflowY: 'auto' }}>
                {selectedFields.map(field => { const fi = allFields.find(f => f.key === field); return <div key={field}>{fi?.label}</div>; })}
              </div>
            </Form.Item>
            <Form.Item label="Active Filters">
              <div style={{ padding: '10px', background: '#f5f5f5', borderRadius: '4px', maxHeight: '150px', overflowY: 'auto' }}>
                {activeFilters.length === 0 ? <div>No active filters</div> : activeFilters.map(filter => (
                  <div key={filter.id} style={{ marginBottom: '5px' }}>
                    <strong>{filter.field.label}: </strong>
                    {filter.field.type === 'text' && filter.value.join(', ')}
                    {filter.field.type === 'number' && [filter.value.min && `Min: ${filter.value.min}`, filter.value.max && `Max: ${filter.value.max}`].filter(Boolean).join(' | ')}
{filter.field.type === 'date' && filter.value && Array.isArray(filter.value) &&
  `${filter.value[0] ? (typeof filter.value[0].format === 'function' ? filter.value[0].format('YYYY-MM-DD') : new Date(filter.value[0]).toISOString().slice(0, 10)) : ''} to ${filter.value[1] ? (typeof filter.value[1].format === 'function' ? filter.value[1].format('YYYY-MM-DD') : new Date(filter.value[1]).toISOString().slice(0, 10)) : ''}`
}               </div>
                ))}
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </div>

     <ReportComments
  show={showCommentsModal}
  onHide={handleCommentsModalHide}
  selectedLead={selectedLeadForComments}
  baseURL={baseURL}
  selectedFields={selectedFields}  
  allFields={allFields}             
/>
    </div>
  );
};

export default M_ReportBuilder;